<template>
  <div class="EarningOrLost">
    <h3 class="mb-3 text-right">Ganancias y pérdidas</h3>
    <b-card>
      <b-container fluid>
        <!-- User Interface controls -->
        <b-row align-v="center" align-h="between" class="mb-2">
          <b-col sm="4" md="6" cols="6" lg="4" class="my-1">
            <b-button
              pill
              class="btn-card-color text-font-white"
              v-b-modal.modal-money
              >Agregar ganancia o pérdida</b-button
            >
          </b-col>
          <b-col sm="4" md="6" cols="6" lg="4" class="my-1">
            <b-form-group
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group size="md">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Buscar por nombre o correo"
                ></b-form-input>
                <!-- <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >X</b-button
                  >
                </b-input-group-append> -->
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="4" md="8" cols="12" lg="4" class="my-1">
            <b-form-group
              label="Por Página"
              label-cols-sm="6"
              label-cols-md="3"
              label-cols-lg="4"
              label-align-sm="right"
              label-size="sm"
              label-for="perPageSelect"
              class="mb-0"
            >
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="md"
                :options="pageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Main table element -->
        <b-table
          show-empty
          small
          stacked="md"
          class="text-left"
          style="font-family: Montserrat; font-weight: lighter; font-size: 14px"
          id="my-table"
          :items="EarnLostTmp"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          :busy="isBusy"
        >
          <template v-slot:empty>
            <div class="mt-2 text-center">
              <h6>No hay ganancias o pérdidas registrados</h6>
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-dark my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Cargando...</strong>
            </div>
          </template>

          <template v-slot:emptyfiltered>
            <div class="my-2 text-center">
              <h6>No hay elementos con esas especificaciones</h6>
            </div>
          </template>
          <template v-slot:cell(percentage)="row"> {{ row.value }}% </template>
          <template v-slot:cell(affected_accounts)="row">
            {{ row.value }} en total</template
          >
          <template v-slot:cell(total)="row"> ${{ row.value }} </template>
           <template v-slot:cell(created_at)="row"> {{ row.value.substr(0, 10).split('-').reverse().join('-') }} </template>
          <template v-slot:cell(actions)="row">

            <b-button
              title="Eliminar"
              size="sm"
              class="mr-1"
              variant="white"
              v-if="row.item.status_payment_id != 1"
              @click="deleteEarnOrLost(row.item)"
            >
              <v-icon v-show="!hide" name="trash" color="#CF173C"></v-icon>
              <b-spinner
                v-show="hide"
                small
                variant="danger"
                class="align-middle"
              ></b-spinner>
            </b-button>
          </template>
        </b-table>
        <b-col lg="5" class="mx-auto pt-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-container>
    </b-card>
    <b-modal
      id="modal-money"
      ref="modal"
      title-class="text-font-black"
      title="Agregar ganancia o pérdida"
      hide-footer
      footer-class="text-font-black"
      @show="resetModal"
      @hidden="resetModal"
    >
      <b-container>
        <form ref="form" @submit.stop.prevent="ManageFounds">
          <b-row>
            <b-col lg="12">
              <p class="text-font-black" style="font-size: 13px">
                Aquí puedes agregar las ganancias o pérdidas en porcentajes de
                las cuentas de inversión
              </p>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Cuenta de inversión"
                label-for="Cuenta de inversión"
                label-class="text-light-black"
                invalid-feedback="Cuenta de inversión"
              >
                <b-form-select
                  v-model="AccountName"
                  id="AccountName"
                  size="md"
                  :options="accountTmp"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Tipo de transacción"
                label-for="Tipo de transacción"
                label-class="text-light-black"
                invalid-feedback="Tipo de transacción"
              >
                <b-form-select
                  v-model="type_transaction"
                  id="type"
                  size="md"
                  :options="typeTmp"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Porcentaje"
                min="0"
                max="100"
                label-class="text-light-black"
                label-for="amount_inout"
              >
                <b-form-input
                  id="percent"
                  type="number"
                  v-model="percent"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Clave maestra"
                label-class="text-light-black"
                label-for="master_key"
                invalid-feedback="Clave requerida"
              >
                <b-form-input
                  id="master_key"
                  v-model="master_key"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="12" class="mb-3">
              <b-form-group
                label="Descripción"
                label-class="text-light-black"
                label-for="Description"
              >
                <textarea
                  class="form-control"
                  rows="2"
                  label="Description"
                  v-model="description"
                ></textarea>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="6" v-show="!progress1"></b-col>

            <b-col lg="3" md="3" sm="3" cols="6" v-show="!progress1">
              <b-button
                style="border-radius: 12px; border: none"
                class="p-3"
                size="sm"
                @click="resetModal()"
              >
                <span class="text-font-white">Cancelar</span>
              </b-button>
            </b-col>
            <b-col lg="3" md="3" sm="3" cols="6" v-show="!progress1">
              <b-button
                style="border-radius: 12px; border: none"
                class="btn-card-color p-3"
                size="sm"
                @click="ManageFounds()"
              >
                <span class="text-font-white">Agregar</span>
              </b-button>
            </b-col>

            <b-col>
              <div v-show="progress1" class="text-center text-primary mt-3">
                <b-spinner small class="align-middle"></b-spinner>
                <strong class="ml-2">Cargando...</strong>
              </div>
            </b-col>
          </b-row>
        </form>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "EarningOrLost",
  data() {
    return {
      AccountName: "Small Cap Account",
      progress1: false,
      percent: null,
      description: null,
      master_key: null,
      type_transaction: "3",
      accountTmp: [
        { value: "Small Cap Account", text: "Small Cap Account" },
        { value: "Big Account", text: "Big Account" },
        { value: "Big Account 2", text: "Big Account 2" },
        { value: "Minor Investors Account", text: "Minor Investors Account" },
      ],
      typeTmp: [
        { value: "3", text: "Ganancia" },
        { value: "4", text: "Pérdidas" },
      ],
      hide: false,
      isBusy: false,
      EarnLostTmp: [],
      fields: [
        {
          key: "type.name",
          label: "Nombre",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "account",
          label: "Cuenta",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "percentage",
          label: "Porcentaje",
          sortable: true,
        },
        {
          key: "description",
          label: "Descripción",
          sortable: true,
        },
        {
          key: "affected_accounts",
          label: "Cuentas afectadas",
          sortable: true,
        },
        {
          key: "total",
          label: "Dinero afectado",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Fecha",
          sortable: true,
        },
        { key: "actions", label: "Acciones" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() {
    this.getDataEarnLost();
  },
  methods: {
    ...mapActions(["getAllEarnLost", "StoreByPercent", "ChangeEarnLostStatus"]),
    resetModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-money");
      });
      this.master_key = "";
      this.type_transaction = "3";
      this.percent = "";
      this.description = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDataEarnLost() {
      this.isBusy = true;
      this.getAllEarnLost()
        .then((response) => {
          if (response.code == 200) {
            this.EarnLostTmp = response.data;
            this.totalRows = response.data.length;
            this.isBusy = false;
          }
        })
        .catch((error) => {
          console.log(error);
          alert("Ocurrió un error, intente más tarde");
        });
    },
    ManageFounds() {
      if (this.AccountName == "Cuenta de liquidez") {
        Swal.fire({
          title: "Atención",
          text: "Las ganancias y pérdidas solo puedes agregarse en cuentas de inversión",
          icon: "error",
        });
      } else if (this.percent < 0 || this.percent > 100) {
        Swal.fire({
          title: "Atención",
          text: "Debes un porcentaje entre 0 y 100 %",
          icon: "warning",
        });
      } else if (this.master_key == null || this.master_key == "") {
        Swal.fire({
          title: "Atención",
          text: "Debes colocar la clave maestra para continuar",
          icon: "warning",
        });
      } else {
        Swal.fire({
          title: "Atención",
          text:
            "¿Está seguro que desea agregar una operación de " +
            this.percent +
            "% ?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#121419",
          reverseButtons: true,
          confirmButtonText: "Sí, seguro",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            this.progress1 = true;

            let form = {
              type_user_account: this.AccountName,
              type_transaction_id: this.type_transaction,
              percentage: this.percent,
              description: this.description,
              master_key: this.master_key,
            };
            this.StoreByPercent(form)
              .then((response) => {
                if (response.code == 200) {
                  Swal.fire({
                    title: "Listo",
                    text: "Se ha realizado la operación",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.progress1 = false;
                  this.$nextTick(() => {
                    this.$bvModal.hide("modal-money");
                  });
                  this.show_details = false;
                  this.getDataEarnLost();
                } else if (response.code == 400) {
                  Swal.fire({
                    title: "Error",
                    text: "La clave es incorrecta, intente nuevamente",
                    icon: "error",
                  });
                  this.progress1 = false;
                } else {
                  this.progress1 = false;

                  Swal.fire({
                    title: "Error",
                    text: "",
                    icon: "warning",
                  });
                }
              })
              .catch((error) => {
                this.progress1 = false;
                console.log(error);
                Swal.fire({
                  title: "Error",
                  text: "Intente más tarde",
                  icon: "warning",
                });
              });
          }
        });
      }
    },
    deleteEarnOrLost(data) {
      Swal.fire({
        title: "Atención",
        text: "¿Estás seguro que deseas eliminar esta ganancia o pérdida?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        confirmButtonText: "Sí, seguro",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.hide = true;
          let form = {
            id: data.id,
            status: "2",
          };

          Swal.showLoading();
          this.ChangeEarnLostStatus(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: "Listo",
                  text: "Se operación se ha eliminado correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.hide = false;
                this.getDataEarnLost();
              }
            })
            .catch((error) => {
              console.log(error);
              this.hide = false;

              alert("Ocurrió un error, intente más tarde");
              this.getDataEarnLost();
            });
        }
      });
    },
  },
};
</script>
<style scoped>
</style>